/**
 * @file Title.tsx
 * @module TitleComponent
 * @description Lapas virsraksta (document.title) komponente.
 *              Iestata pārlūka cilnes nosaukumu no i18next tulkojuma ("pageTitle").
 */
import { useTranslation } from "react-i18next";

export const TitleComponent = () => {
	const [t] = useTranslation();

	document.title = t("pageTitle");

	return <></>;
};
